import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    error: {
      borderColor: `${theme.palette.error.main} !important`,
    },
  }),
);
